import { render, staticRenderFns } from "./CustomerListDilog.vue?vue&type=template&id=37abbf00&scoped=true&"
import script from "./CustomerListDilog.vue?vue&type=script&lang=js&"
export * from "./CustomerListDilog.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListDilog.vue?vue&type=style&index=0&id=37abbf00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37abbf00",
  null
  
)

export default component.exports